// https://docs.google.com/document/d/1Ol_VXv7nIk5hj8vJo4hzZSVqXX-smbJN67VrLyvq0yU/edit#heading=h.rvpmw095cm0n
export const SHOPPING_PRODUCTS_API_ERROR_MAPPING = {
  1002: '參數驗證錯誤', // Parameter validation error
  1101: 'token驗證失敗', // Token validation error
  1102: '未登入', // Not logged-in
  1103: '未登入', // Not logged-in
  2001: '無資料', // Data not found
  4111: '封館賣場限定存取，該YTCookie驗證後的使用者不符合資格', // Particular member only
  4114: '封館賣場活動尚未開始', // Particular member act not started
  4115: '封館賣場活動已經過期' // Particular member act expired,
}
